import { Panel } from '../ui/Panel';
import { OpeningHoursEditor } from '../ui/OpeningHoursEditor';
import { SalonExceptionsEditor } from './SalonExceptionsEditor';
import { useSettings } from './useSettings';
import { staffList } from '../../core/rules/salonDays';

/** Instellingen › Salondagen: de vaste week en de dagen die daarvan afwijken. */
export function SalonDaysSettings() {
  const {
    site,
    setSite
  } = useSettings();
  const team = staffList(site.staff);
  return <>
      <Panel title="Vaste week" description="Op afspraak. Deze dagen bepalen welke dagen en tijden klanten online kunnen boeken, en wie er die dag behandelt." data-id="element-4245" data-mp="tzokpx7uj7lt">
        <OpeningHoursEditor value={site.openingHours} staff={team} onChange={openingHours => setSite(s => ({
        ...s,
        openingHours
      }))} data-id="element-4246" data-mp="12xh2d811ircd" />
      </Panel>
      <Panel title="Afwijkende dagen" description="Vakantie, een extra dag of een ruil. Gaat voor de vaste week, ook voor online boeken. Afspraken die daardoor niet meer kloppen, zie je in de agenda." data-id="element-4247" data-mp="34p3lyoilrjyt">
        <SalonExceptionsEditor value={site.salonExceptions ?? []} staff={team} onChange={salonExceptions => setSite(s => ({
        ...s,
        salonExceptions
      }))} data-id="element-4248" data-mp="rsaj3ju8zcoy" />
      </Panel>
    </>;
}